import script from "./SettlementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__